import { BirimeklePage } from './../birimekle/birimekle';
import { BllOrtak } from './../../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams, ModalController } from 'ionic-angular';
import { Ortak } from '../../../../providers/ortak';

/**
 * Generated class for the BirimListePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-birim-liste',
  templateUrl: 'birim-liste.html',
})
export class BirimListePage {
  aranan="";
skip:number=0;
take:number=100;
BirimListesi=[];

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public modalCtrl:ModalController,
     public navParams: NavParams) {
  }

  ionViewDidLoad() {
    this.kayitAra(null);
  }

  kayitAra(e) {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "BirimListesi","", false).then(a => {
     
      var sonuc = <any>a;
      this.BirimListesi = sonuc.SonucObject;
   
   
 
    })
  }
  
  birimkayitlari(e) {

    if (e.keyCode == 13) {
      this.kayitAra(e);
    }
  }
  yenikayit() {
    let modal = this.modalCtrl.create(BirimeklePage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });

    modal.present();

  }
  kayitduzenle(birim){
    let modal = this.modalCtrl.create(BirimeklePage, { BirimVw: birim });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
   
  }
  BirimSil(birim) {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();
      
      formData.append("ID", birim.ID);

      this.bllOrtak.islem(formData, "BirimSil", "", true).then(a => {

      }).catch(x => {

        this.ortak.showErrorAlert();
      })
      this.kayitAra("");
     
    })
   
  }


}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/BirimIslemleri/birim-liste/birim-liste.ts